import { SelfSacrificeConfig } from 'game/extended/heros/paladin/self_sacrifice/self_sacrifice'

export const self_sacrifice_config: Array<SelfSacrificeConfig> = [
    {
        cooldown: 5
    },
    {
        cooldown: 2
    }
]